import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class BreadCrumb extends Component {

    render() {

        let parents_mapping = this.props.parents.map(el => {
            return <li key={el.title} style={{ display: 'flex', alignItems: 'center', listStyle: 'none' }}>
                <Link to={el.route} style={{ color: '#5578f4', textDecoration: 'none', fontWeight: '500' }}>{el.title}</Link>
            </li>
        })

        return (
            <div className="policy-breadcrumb" style={{ background: '#eef1fb', padding: '11px 0', borderBottom: '1px solid #e1e7f8', width: '100%' }}>
                <div className="container">
                    <ul className="policy-breadcrumb-nav" style={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0, listStyle: 'none' }}>
                        {parents_mapping}
                        <li className="active" style={{ display: 'flex', alignItems: 'center', listStyle: 'none', color: '#666' }}>
                            <span>{this.props.title}</span>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}
